export default "__VITE_ASSET__D$OnXsa1__"